import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { TaskFindingStatus } from "../../../shared/types";

// PRD-0084 — finding triage (Done / Dismiss) on the operator brief report.
// Wraps the existing PATCH /api/task-findings/:id/dismiss endpoint (ownership-checked,
// writes task_findings.status + acted_at). Invalidates the brief + dashboard summary
// so the report and KPIs reflect the new state.
export function useSetFindingStatus(runId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: { findingId: string; status: TaskFindingStatus }) =>
      api.patch<{ data: { id: string; status: TaskFindingStatus } }>(
        `/api/task-findings/${encodeURIComponent(payload.findingId)}/dismiss`,
        { status: payload.status },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["task-run-brief", runId] });
      qc.invalidateQueries({ queryKey: ["brand-stats"] });
    },
  });
}
